import * as actionTypes from './actionTypes';
import { accountService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidateAccess } from '@app/src/common/session';

const hashAccountRequest = () => ({
  type: actionTypes.HASH_ACCOUNT_REQUEST
});

const hashAccountFailure = () => ({
  type: actionTypes.HASH_ACCOUNT_FAILURE
});

const hashAccountSuccess = (data) => ({
  type: actionTypes.HASH_ACCOUNT_SUCCESS,
  data
});

export const fetchAccountHash = (json) => {
  return async dispatch => {
    dispatch(hashAccountRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await accountService.post(json);
      dispatch(hashAccountSuccess(data && data.data && data.data[0]));
      if (data.error) {
        dispatch(hashAccountFailure());
      } /* else {
        setTimeout(() => {
          window.location.href = `${process.env.PATH_ROOT}/inicia-tu-sesion`;
        }, 1000)
      } */
    } catch(error) {
      console.log(error, 'error')
      dispatch(actionsModalError.openModalError());
      dispatch(hashAccountFailure());
    }
  }
}
